<template>
  <v-container fluid>
    <PageHeaderSlot />

    <v-card>
      <v-card-text class="px-2">
        <v-row class="ma-0">
          <v-col cols="12" sm="6" lg="3" v-for="type in typeKeys" :key="`download_${type}`">
            <div class="export-block px-4 py-8">
              <span class="text-subtitle-1 colorBlack--text font-medium mb-8 text-capitalize">
                {{ $t(`reportTypes.${type}`) }}
              </span>
              <FormButton color="#c3dec5" text="table.download" @click="handleDownloadReport(type)">
                <template slot="prepend"><v-img src="~@/assets/images/excel.svg" alt="excel"></v-img></template>
              </FormButton>
            </div>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>

    <!-- Modal: 選擇Date Range -->
    <FormDialog
      ref="dateRangeFormDialog"
      formRef="dateRangeForm"
      :title="getModalName()"
      enableCancel
      btnAlign="center"
      confirmBtnText="table.download"
      :maxWidth="500"
    >
      <v-row class="ma-0">
        <v-col cols="12" v-if="getReportType() !== 'student' && getReportType() !== 'package'">
          <FormDatePicker
            placeholder="table.searchDateRange"
            :dateValue.sync="filterDate"
            isDateRange
            disableClear
            required
          />
        </v-col>
        <v-col cols="12">
          <FormSelect
            label="campus"
            placeholder="selectCampus"
            :fieldValue.sync="filterSchool"
            :options="tutorSchoolOptions"
          />
        </v-col>
      </v-row>
    </FormDialog>
  </v-container>
</template>

<script>
import FormDatePicker from '@/components/formField/FormDatePicker.vue'
import FormDialog from '@/components/FormDialog.vue'
import FormSelect from '@/components/formField/FormSelect.vue'

export default {
  name: 'Report',
  components: {
    FormDatePicker,
    FormDialog,
    FormSelect,
  },
  computed: {
    typeKeys() {
      return [
        'sales',
        'accounting',
        ...(!this.disableTutorSalary && this.$validate.allowAction('viewSalary', this.userType) ? ['salary'] : []),
        'refund',
        ...(this.isAppMode(['T03']) ? ['student'] : []),
        ...(!this.isAppMode(['T01']) ? ['package'] : []),
        ...(this.gEnableWarehouse ? ['product'] : []),
        ...(this.isAppMode(['DEV', 'UAT']) && !this.isAppMode(['T01']) ? ['new_student'] : []), // TODO: #407
      ]
    },
    // permission & setting
    // Hidden 薪酬報告
    disableTutorSalary() {
      return this.$validate.DataValid(this.$excludeMenuList) && this.$excludeMenuList.includes('tutor-salary')
    },
  },
  data: vm => ({
    userType: vm.gfGetUserType(),
    filterDate: [],
    filterSchool: null,

    tutorSchoolOptions: [],
  }),
  methods: {
    getModalName() {
      const type = this.getReportType()
      if (type) {
        return this.$t('reportDownload', { name: this.$t(`reportTypes.${type}`) })
      }

      return ''
    },
    getReportType() {
      if (this.$refs && this.$refs.dateRangeFormDialog) {
        return this.$refs.dateRangeFormDialog.getInfo()
      }
      return ''
    },

    // -- (下載)
    async handleDownloadReport(type, newOpen = true) {
      if (newOpen) {
        if (this.$store.getters.isLoading) {
          this.$store.dispatch('toggleSnack', { message: 'processing' })
          return
        }

        this.$refs.dateRangeFormDialog.setInfo(type)
        this.filterDate = []
        this.filterSchool = null
        await this.$refs.dateRangeFormDialog.resetForm()
        const selectedSchool = this.gfGetUserSelectedSchool()
        if (selectedSchool > -1) {
          this.filterSchool = selectedSchool
        }
      } else {
        this.$refs.dateRangeFormDialog.setLoading(false)
      }
      const confirm = await this.$refs.dateRangeFormDialog.show()
      if (confirm) {
        try {
          let payload = {}
          if (this.filterDate.length > 0) {
            payload['start_date'] = this.filterDate[0]
            payload['end_date'] = this.filterDate[0]
            if (this.filterDate.length > 1) {
              payload['end_date'] = this.filterDate[1]
            }
          }
          if (this.$validate.DataValid(this.filterSchool) && this.filterSchool > -1) {
            payload['center_id'] = this.filterSchool
          }
          switch (type) {
            case 'sales':
              await this._downloadReport('export_excel', payload)
              break
            case 'accounting':
              await this._downloadReport('stat_excel', payload)
              break
            case 'salary':
              await this._downloadReport('salary_excel', payload)
              break
            case 'refund':
              await this._downloadReport('refund_excel', payload)
              break
            case 'student':
              await this._downloadReport('student_excel', payload)
              break
            case 'package':
              await this._downloadReport('package_usage_excel', payload)
              break
            case 'product':
              await this._downloadReport('product_report', payload)
              break
            case 'new_student':
              await this._downloadReport('new_apply_student', payload)
              break
          }
          this.$refs.dateRangeFormDialog.hide()
        } catch (err) {
          this.$common.error(err)
          if (err !== 'abort') {
            this.showAlert({
              title: 'message.downloadFail',
              message: err,
              isError: true,
            })
          }

          this.handleDownloadReport(type, false)
        }
      }
    },
    _downloadReport(key, payload = null) {
      return new Promise(async (resolve, reject) => {
        try {
          const file = await this.$Fetcher.ExportReport(key, payload)
          var download = document.createElement('a')
          download.download = file
          download.href = `${this.$mediaPath}${file}`
          download.style.display = 'none'
          download.target = '_blank'
          document.body.appendChild(download)
          download.click()
          download.remove()
          resolve(file)
        } catch (err) {
          this.$common.error(err)
          reject(err)
        }
      })
    },

    // ======== 分校 Options =======
    async _getTutorSchoolOptions() {
      try {
        const { data } = await this.$Fetcher.GetSchools()
        const filtered = data.filter(el => el.active === true)
        if (this.$validate.DataValid(filtered)) {
          this.tutorSchoolOptions = filtered.map(el => {
            return {
              value: el.id,
              text: el.name,
            }
          })
        }

        // 只會攞staff所屬嘅分校
        const getUserSchools = this.gfGetUserSchools()
        this.tutorSchoolOptions = this.tutorSchoolOptions.filter(el => getUserSchools.includes(el.value))

        if (this.tutorSchoolOptions.length === filtered.length) {
          this.tutorSchoolOptions.unshift({ value: -1, text: this.$t('allCenters') })
        }
      } catch (err) {
        this.$common.error(err)
      }
    },

    async handleSiteLoaded() {
      this.$common.log('>>>>>>>>>>>>>>>>>>>>>>>>>>>> handleSiteLoaded: 報表下載')
      this.userType = this.gfGetUserType()
      await this._getTutorSchoolOptions()
      this.$store.dispatch('toggleLoadingPage', false)
    },
  },
  destroyed() {
    window.removeEventListener('onSiteLoaded', this.handleSiteLoaded)
  },
  mounted() {
    this.$store.dispatch('toggleLoadingPage', true)
    window.addEventListener('onSiteLoaded', this.handleSiteLoaded)
  },

  // ------ navigation guard ------
  beforeRouteLeave(to, from, next) {
    this.$XHR.abort()
    next()
  },
}
</script>

<style lang="scss" scoped>
.export-block {
  width: 100%;
  display: flex;
  flex-direction: column;
  border: 2px solid #1b718a;
  border-radius: 5px;
  background-color: #ffffff;
  align-items: center;

  & > .v-btn {
    background-color: #c3dec5;
    border-radius: 11px;
    color: #2e7d32;
    font-size: 0.875rem;
    font-weight: 500;

    & .v-image {
      height: 20px;
      width: 20px;
      min-width: 20px;
      margin-right: 0.5em;
    }
  }
}
</style>
